// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function execute(payload) {
  return {
          address: Belt_Option.map(payload.address, (function (addr) {
                  return {
                          receiver_name: addr.receiver_name,
                          receiver_phone: addr.receiver_phone,
                          address_line_1: addr.address_line_1,
                          address_line_2: addr.address_line_2,
                          city: addr.city,
                          state: addr.state,
                          postal_code: addr.postal_code
                        };
                })),
          items: Belt_Option.map(payload.items, (function (items) {
                  return Belt_Array.map(items, (function (item) {
                                return {
                                        sku: item.sku,
                                        quantity: item.quantity
                                      };
                              }));
                })),
          crm_status: payload.crm_status
        };
}

export {
  execute ,
  
}
/* No side effect */
